import Bowser from 'bowser';
import { includes } from 'lodash';

import { AuthLocalStorageKeys } from 'common/auth/constants';
import { getCurrentLng } from 'common/i18n/i18n';
import { hideOverriddenPendoTrainings } from 'common/utils/hideOverriddenPendoTrainings';
import { isSecurityQuestionMissing } from 'module/auth/login/login.utils';

import type { ActiveStudySite, AuthUser } from '../auth/types';

import type { Analytics } from './analytics.provider';

export default class PendoAnalytics implements Analytics {
    public initialize(user?: AuthUser): void {
        window?.pendo?.initialize?.({
            ...(!!user && {
                events: {
                    guidesLoaded: () => hideOverriddenPendoTrainings(user),
                },
            }),
        });
    }
    public identifyUser(user: AuthUser): void {
        const { os, platform } = Bowser.parse(window.navigator.userAgent);
        const { pk, oldUserId, email, username, subType, userStudies, roleBClaim, roleVClaim, createdAt, type } = user;
        const activeStudySite: ActiveStudySite = JSON.parse(localStorage.getItem(AuthLocalStorageKeys.activeStudySite));

        const hasNotAcceptedCurrentPolicyOrNoPermissionRequired =
            (!user?.currentPolicy?.[0] || user?.acceptedVersionPP !== user?.currentPolicy?.[0]?.majorVersion) &&
            includes(user?.permissions, 'SubscriberPP_Read');

        if (hasNotAcceptedCurrentPolicyOrNoPermissionRequired || isSecurityQuestionMissing(user)) {
            return;
        }

        const pendo = window.pendo;

        // on guides loaded hide any trainings that have been overridden by training override in admin
        pendo?.events?.guidesLoaded?.(function () {
            hideOverriddenPendoTrainings(user);
        });

        pendo?.identify?.({
            visitor: {
                id: oldUserId || pk,
                email,
                userCreation: createdAt,
                username,
                userType: type,
                subType,
                language: getCurrentLng(),
                preferredLanguage: getCurrentLng(),
                studyId: activeStudySite?.activeStudy?.studyId || userStudies[0]?.studyId,
                siteId: activeStudySite?.activeSite?.siteId || userStudies[0]?.userStudySites[0]?.siteId,
                baseRole: roleBClaim?.data,
                roleVariant: roleVClaim?.name,
                device: platform.type === 'desktop' ? 'Web' : platform.type,
                operatingSystem: os.name,
                osVersion: os.version,
            },
            account: {
                id: user.subscriberPk,
                // name:         // Optional
                // planLevel:    // Optional
                // planPrice:    // Optional
                // creationDate: // Optional

                // You can add any additional account level key-values here,
                // as long as it's not one of the above reserved names.
            },
        });
    }
    public anonymousUser(pendoObj): void {
        const { os, platform } = Bowser.parse(window.navigator.userAgent);
        (window as any).pendo[pendoObj]({
            visitor: {
                language: getCurrentLng(),
                preferredLanguage: getCurrentLng(),
                device: platform.type === 'desktop' ? 'Web' : platform.type,
                operatingSystem: os.name,
                osVersion: os.version,
            },

            account: {
                //
            },
        });
    }

    public clearSession() {
        (window as any).pendo.clearSession();
    }

    public track(): void {}
}
